module.exports = __webpack_public_path__ + "img/seta.2934340d.svg";